import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LibraryPage } from "../../../pages/library-page/library-page";

export const Route = createFileRoute("/_auth/_frame/library")({
  validateSearch: z.object({ tab: z.literal("abacus").optional().catch(undefined) }),
  component: LibraryPage,
});
